import React from 'react'
import Hearclients from "../Components/HRC/Hearclients"
import Testimonials from '../Components/HRC/Testimonials'

const PageThree = () => {
  return (
    <div>
        <Hearclients />
        <Testimonials />
    </div>
  )
}

export default PageThree